import * as tslib_1 from "tslib";
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '../../../core';
var FormlyWrapperDescription = (function (_super) {
    tslib_1.__extends(FormlyWrapperDescription, _super);
    function FormlyWrapperDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyWrapperDescription;
}(FieldWrapper));
tslib_1.__decorate([
    ViewChild('fieldComponent', { read: ViewContainerRef }),
    tslib_1.__metadata("design:type", ViewContainerRef)
], FormlyWrapperDescription.prototype, "fieldComponent", void 0);
FormlyWrapperDescription = tslib_1.__decorate([
    Component({
        selector: 'formly-wrapper-description',
        template: "\n    <ng-container #fieldComponent></ng-container>\n    <div>\n      <small class=\"text-muted\">{{ to.description }}</small>\n    </div>\n  ",
    })
], FormlyWrapperDescription);
export { FormlyWrapperDescription };
//# sourceMappingURL=description.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/wrappers/description.js
// module id = 782
// module chunks = 3